module.exports = __webpack_public_path__ + "static/media/card_icon.01c26eb9.svg";